import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router';

import { EnvConfig } from '../config/configMapping';
import { logger } from './logger';
import { setSentryReportingEnabled } from './sentryReporting';

export const initSentry = (envConfig: EnvConfig): void => {
  if (!envConfig.sentry.enabled) {
    logger.debug('Sentry is disabled');
    return;
  }

  try {
    Sentry.init({
      dsn: envConfig.sentry.dsn,
      environment: envConfig.environment,
      release: envConfig.gitSha,
      // Post envelopes to our own backend rather than Sentry's ingest host, which ad blockers and
      // corporate egress filters drop by hostname. Without this we simply never hear about the
      // crashes of the users most likely to be on a locked-down machine.
      tunnel: envConfig.sentry.tunnel,
      integrations: [
        Sentry.reactRouterV7BrowserTracingIntegration({
          useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
      ],
    });

    // Set some test data
    Sentry.setTag('gitSha', envConfig.gitSha);

    // /** Add the configurations to the context */
    Sentry.setContext('Configurations', envConfig);

    // Flipped only after init actually succeeds: this is what licenses the error screen to
    // offer its event id as a support reference.
    setSentryReportingEnabled(true);

    logger.debug('Sentry initialization completed');
  } catch (err) {
    const error = err as Error;
    logger.error('Failed to initialize Sentry:', error.message);
  }
};
